import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import AlertIcon from '@mui/icons-material/Warning';

import Grid from '@mui/material/Grid';
import accessDenied from '../../../images/unused-undraw-illustrations/undraw_access_denied_re_awnf.svg';
import AppStoreButton from '../../AppStoreButton';
import NotInvitedCardComponent from '../NotInvitedCard';

const defaultCardStyle = {
  width: '500px',
  margin: 'auto',
  maxWidth: '90vw',
};
const buttonContainer = {
  margin: '2rem auto 1rem',
  display: 'block',
  width: 'fit-content',
};
const imageContainer = {
  width: 250,
  display: 'block',
  margin: 'auto',
  marginBottom: '1rem',
};

const LimitedPaidClientAccessCardComponent = ({
  selectedBarn = { name: 'Your barn' },
  checkEmailUser,
}) => {
  if (!checkEmailUser || !checkEmailUser.invited) { return <NotInvitedCardComponent selectedBarn={selectedBarn || {}} /> }
  return (
    <Box sx={{ mt: 2 }}>
      <Card style={defaultCardStyle}>
        <CardHeader
          title={`${selectedBarn.name || ''} Web Access`}
          subheader="Your web access is limited to viewing the Barn Board."
        />
        <CardContent>
          <img src={accessDenied} alt="man access denied app" style={imageContainer} />
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
              m: 1,
            }}
          >
            <Chip
              icon={<AlertIcon />}
              color="warning"
              label="Board View Only"
            />
          </Box>
          <Typography variant="body2" gutterBottom>
            You can view your barn board on the web. For horse details, schedules, notes, and additional
            client features, use the Questri mobile app.
          </Typography>
          <div style={buttonContainer}>
            <Button
              color="primary"
              size="small"
              href="/board"
              target="_top"
              variant="contained"
            >
              Open Barn Board
            </Button>
          </div>
          <Divider
            sx={{
              mt: 2,
              mb: 2,
            }}
          />
          <Typography variant="h5" align="center" gutterBottom color="primary">
            Need additional web access?
          </Typography>
          <Typography variant="body2" component="div" align="center" gutterBottom>
            Contact an admin at <b>{selectedBarn.name}</b> if you need a different role.
          </Typography>
          <Grid container justifyContent="center" spacing={2}>
            <Grid>
              <Box
                sx={{
                  display: 'inline-flex',
                  borderRadius: 1,
                  backgroundColor: '#fff',
                  p: 0.5,
                }}
              >
                <AppStoreButton
                  store="ios"
                  url="https://apps.apple.com/us/app/questri/id1634821513"
                  width={150}
                  height={60}
                />
              </Box>
            </Grid>
            <Grid>
              <Box
                sx={{
                  display: 'inline-flex',
                  borderRadius: 1,
                  backgroundColor: '#fff',
                  p: 0.5,
                }}
              >
                <AppStoreButton
                  store="android"
                  url="https://play.google.com/store/apps/details?id=app.questri"
                  width={150}
                  height={60}
                />
              </Box>
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
};

LimitedPaidClientAccessCardComponent.propTypes = { selectedBarn: PropTypes.object };

LimitedPaidClientAccessCardComponent.defaultProps = { selectedBarn: { name: 'Your barn' } };

export default LimitedPaidClientAccessCardComponent;
